import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Cookies from 'js-cookie'
import config from '../config/base'
import axios from 'axios'
import qs from 'qs'
import callApi from '../helpers/callapi'
import jwt from 'jsonwebtoken'
import { useLocation, useHistory } from 'react-router-dom'
import randomstring from 'randomstring'
import swal from 'sweetalert2'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export default function Login() {
  let history = useHistory()

  const dispatch = useDispatch()
  const query = useQuery()
  const accessToken = Cookies.get('accessToken')

  const [isToken, setToken] = useState(false)

  let baseUrl =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '')

  let redirectUrl = `${baseUrl}/member`

  if (query.get('redirect')) {
    redirectUrl = `${baseUrl}/member?redirect=${query.get('redirect')}`
  }
  const redirectUrlEncode = encodeURIComponent(redirectUrl)

  let clientId = config.lineClientId
  let clientSecret = config.lineClientSecret
  const state = randomstring.generate({ length: 8, charset: 'alphabetic' })
  const scope = 'profile%20openid'
  const nonce = 'kslplusonline9999'
  const fullUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUrlEncode}&state=${state}&bot_prompt=aggressive&scope=${scope}&nonce=${nonce}`

  return (
    <BlockLine>
      <div className="container">
        <div className="card">
          <img
            src="/img/logo-kslplus.png"
            alt="กองสลากพลัส"
            className="logo"
            style={{ maxWidth: '70%', maxHeight: '100px', width: 'auto' }}
          />
          <form className="card-form">
            <button
              type="button"
              className="card-button"
              onClick={() => {
                Cookies.remove('accessToken')
                // window.close();
                window.open(fullUrl, '_self')
              }}
            >
              <div className="box_Btn_line">
                <img src="/img/logo_line.png" alt="line" />
                <div className="text_btn">
                  <h3
                    style={{
                      color: 'white',
                      marginButton: '0',
                      padding: '5px',
                    }}
                  >
                    Line
                  </h3>
                </div>
              </div>
            </button>
          </form>
          <small className="card-subtitle">เข้าสู่ระบบด้วยไลน์</small>
        </div>
      </div>
    </BlockLine>
  )
}

const BlockLine = styled.div`
  background-image: url('/img/logo_Bird.png');
  background-repeat: no-repeat;
  background-position: right top;
  background-size: auto;

  justify-content: center;
  align-items: center;
  display: flex;
  height: 100vh;
  width: 100%;

  .container {
    height: 100vh;
    display: grid;
    font-family: 'poppins', Arial, Helvetica, sans-serif;
    place-items: center;
  }
  .card {
    box-shadow: #565656 0px 3px 10px;
    justify-content: center;
    /* border: 1px solid #eb1b23; */
    box-sizing: border-box;
    flex-direction: column;
    align-items: center;
    background: #ffffff;
    border-radius: 20px;
    max-height: 300px;
    min-height: 300px;
    max-width: 600px;
    display: flex;
    padding: 2em;
    width: 100%;

    .card-form {
      padding: 10px;
    }

    @media (max-width: 425px) {
      box-shadow: none;
    }
  }

  .card-title {
    align-items: center;
    font-size: 40px;
    color: #06c755;
  }

  .card-subtitle {
    margin: 5px 0;
    color: #565656;
  }
  .card-button {
    font-family: 'poppins', Arial, Helvetica, sans-serif;
    border-radius: 10px;
    min-width: 250px;
    max-width: 400px;
    outline: none;
    border: none;
  }

  .card-button {
    margin-bottom: 1rem;
    background: #06c755;
    cursor: pointer;
    color: #f4f4f4;
    padding: 4px;
    width: 100%;

    @media screen and (max-width: 320px) {
      padding: 2px;
    }
  }

  .card-button:focus,
  .card-button:hover {
    background: #06c755;
  }

  .box_Btn_line {
    flex-direction: row;
    text-align: center;
    overflow: hidden;
    display: flex;
    img {
      height: 40px;
      width: 40px;
      margin: auto;
    }

    .text_btn {
      border-left: 1px solid #e5e5e5;
      text-align: center;
      width: 85%;

      h3 {
        line-height: inherit;
        font-weight: 600;
      }
      @media screen and (max-width: 320px) {
        h3 {
          font-size: 16px;
          font-weight: 600;
        }
      }
    }

    @media screen and (max-width: 320px) {
      img {
        width: 40px;
        height: 35px;
        margin: auto;
      }
    }
  }
`
